export default __webpack_public_path__ + "static/media/main.8857121e.svg";